import Splide from '@splidejs/splide';

function carouselSolid() {
    const carouselSolidCards = document.querySelectorAll('.splide--carousel_solid');

    carouselSolidCards.forEach((item) => {
        const splide = new Splide(item, {
            drag: true,
            autoWidth: false,
            pagination: true,
            arrows: false,
            type: 'loop',
            focus: 'center',
            perPage: 1,
            perMove: 1,
            padding: { left: '30vw', right: '30vw' },
            gap: 30,
            speed: 600, // Velocidad de transición consistente
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)', // Easing suave
            rewind: false, // Evita recalculo al volver
            waitForTransition: false, // NO espera a que termine la transición
            updateOnMove: false, // NO actualiza durante movimiento
            trimSpace: false, // NO recorta espacio extra
            breakpoints: {
                1024: {
                    perPage: 1,
                    perMove: 1,
                    padding: { left: 150, right: 150 },
                    gap: 15
                },
                768: {
                    perPage: 1,
                    perMove: 1,
                    padding: { left: 120, right: 120 },
                    gap: 15
                },
                576: {
                    perPage: 1,
                    perMove: 1,
                    padding: { left: 30, right: 30 },
                    gap: 15
                }
            }
        });

        splide.mount();
    });
}

export default carouselSolid;